import { object, ObjectSchema, mixed } from 'yup';

import supportsOneOf from 'helpers/supportsOneOf';

import { TimeFrames } from 'components/TopicFilters/shared';

export type ViewSettings = {
  timeframe: 'twtd' | 'lw';
};

const getSchemas = (): ObjectSchema<ViewSettings> => {
  if (!supportsOneOf()) {
    return object({
      timeframe: mixed<TimeFrames>().required().default('twtd'),
    });
  }

  return object({
    timeframe: mixed<TimeFrames>()
      .required()
      .oneOf(['twtd', 'lw'])
      .default('twtd'),
  });
};

export default getSchemas;
